import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useCopilot } from './CopilotContext';

/**
 * Bottom-right floating button that opens the Copilot panel. Hidden while the
 * panel is open (the panel has its own close control).
 */
export function CopilotLauncher() {
  const { panelOpen, togglePanel } = useCopilot();

  return (
    <AnimatePresence>
      {!panelOpen && (
        <motion.button
          type="button"
          onClick={togglePanel}
          initial={{ opacity: 0, scale: 0.6, y: 12 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 12 }}
          transition={{ type: 'spring', stiffness: 400, damping: 26 }}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.94 }}
          className="group fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-lg shadow-primary/30 ring-1 ring-primary/40 hover:bg-primary/90"
          aria-label="Open Copilot"
        >
          {/* soft pulse ring */}
          <span className="absolute inset-0 rounded-full bg-primary/40 motion-safe:animate-ping [animation-duration:2.5s]" />
          <Sparkles className="relative h-6 w-6" />
          <span className="pointer-events-none absolute right-16 whitespace-nowrap rounded-lg bg-slate-900 px-2.5 py-1 text-xs font-medium text-white opacity-0 shadow-md transition-opacity group-hover:opacity-100">
            Ask Copilot
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
